import { Script } from "gatsby";
import React from "react";

// This is the verbatim code snippet sent to us.

export default function EIETracking() {
  return (
    <>
      <Script id="eie-tracking-vars">{`
var GTM_EVT_REGION = 'eu';
var GTM_EVT_TOKEN = 'AsdeifXs9sIF3RvpOE5tVnx1Pl3EK0RXVsCvFNZiHQX4xBzVYXxFLkRgp3HTqgJN6MNUjeG8ftMxNqNj';
  `}</Script>
      <Script id="eie-tracking-script">{`
var contextScript = document.createElement('script');
contextScript.setAttribute('src','https://cdn.jsdelivr.net/npm/@evrythng/context-script@1/dist/context-script.js?v=' + Date.now());
document.head.appendChild(contextScript);
`}</Script>
    </>
  );
}
